import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import SelectComponent from "../../HelperComponents/SelectComponent/SelectComponent";
import { getDocumentNumbers } from "../../../actions/refundRequestsActions";
import "./RefundRequestsStatusForm.scss";

class RefundRequestsStatusWholesaleForm extends Component {
  state = {
    documentNumbers: [],
    selectedDocumentNumber: undefined,
  };

  componentDidMount() {
    const { requestId, getDocumentNumbers } = this.props;

    getDocumentNumbers(requestId).then((res) => {
      if (res.payload && res.payload.status && res.payload.status === 200) {
        console.log(res);
        this.setState({ documentNumbers: res.payload.data || [] });
      }
    });
  }

  handleSelectDocumentNumber = (formValue) => {
    this.setState({ selectedDocumentNumber: formValue });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { handleDialog } = this.props;
    const { selectedDocumentNumber, documentNumbers } = this.state;

    const selectedDocument =
      selectedDocumentNumber &&
      documentNumbers.find(
        (document) => document.document_number === selectedDocumentNumber.value
      );

    handleDialog("complete", {
      status: "complete",
      invoice_number: selectedDocumentNumber && selectedDocument.document_number,
      invoice_date: selectedDocumentNumber && selectedDocument.date,
    });
  };

  render() {
    const { toggleDialogOpen, loading } = this.props;
    const { selectedDocumentNumber, documentNumbers } = this.state;

    return (
      <form
        className="refund_requests_status__form"
        onSubmit={this.handleSubmit}
      >
        <h3 className="title-dialog">Одобрить заявку на возврат</h3>
        <div className="flex flex-column gap-20">
          {documentNumbers && !!documentNumbers.length && (
            <SelectComponent
              classes="form-item"
              placeholder={"Выберите номер выдачи"}
              value={selectedDocumentNumber}
              change={this.handleSelectDocumentNumber}
              options={documentNumbers.map(({ document_number }) => ({
                label: `${document_number}`,
                value: document_number,
              }))}
            />
          )}
        </div>
        <div className="btn-wrapper order-dialog-btn">
          <DefaultButton
            variant="outlined"
            classes="cancel_btn"
            onClick={toggleDialogOpen}
          >
            Отмена
          </DefaultButton>
          <DefaultButton
            disabled={!selectedDocumentNumber}
            loading={loading}
            formAction
          >
            Одобрить
          </DefaultButton>
        </div>
      </form>
    );
  }
}

RefundRequestsStatusWholesaleForm = reduxForm({
  form: "RefundRequestsStatusWholesaleForm",
})(RefundRequestsStatusWholesaleForm);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDocumentNumbers,
    },
    dispatch
  );
}

export default connect(
  undefined,
  mapDispatchToProps
)(RefundRequestsStatusWholesaleForm);
